import axios from "axios";
import moment from "moment";
import Swal from "sweetalert2";
// import PatientsSearchComponent from "../VeinsTracker/PatientsSearchComponent.vue";
import PatientsSearchComponent from "../../VeinsTracker/PatientsSearchComponent.vue";
import QuickCheckinInfo from "../../Patients/QuickCheckinInfo.vue";

export default {
  name: "QuickCheckinMain",
  props:['showQuickCheckinInfo','getPatientFromMain'],
  components: { 
    PatientsSearchComponent,
    QuickCheckinInfo
   },
 
  data() {
    return {
    NewPat: "",
    hideMain:true,
    showPagesMin:1,
    showPagesMax:5,
    pat:null,
    vDos: new Date(),
    Dos_1: "", 
    newdate: "",
    
    practName: "",
    call: {},
    call1: {},
    loaderTim1: {},

    loaderTim: {},
    sortColumn: 0,
    sortColumnOption: 0,
    isNew: false,
    patientId: 0,
    valueSSN: "",
    //loader
    loader: "",
    loader1: "",

    //pagina
     pageNumber: 1,
      pageSize: 50,
      orderByCol: 1,
      asc_desc: "asc",
      remeberOrder: "",
      firstTime: true,
      totalPages: 0,
      totalRows: 0,

    Insurance: {
        primaryInsuranceName: "",
        primaryInsuranceNumber: "",
        primaryInsuranceGroup: "",
        primaryInsuranceId: "",
        secondaryInsuranceName: "",
        secondaryInsuranceNumber: "",
        secondaryInsuranceGroup: "",
        secondaryInsuranceId: ""
      },
    PhysicianId: "",
    contactInfo: ["phone","email"],
    choseBasic: [],
    demoClick: [],
    
    basicDetails: {
        pndx: 0,
        patientId: 0,
        firstName: "",
        lastName: "",
        currentdate: new Date(),
        dos: "",
        dob: "",
        gender: "",
        ssn: "",
        phone: "",
        email: "",
        address: "",
        city: "",
        zip: "",
        state: "",
      },
      newValDOB: "",
      emailRq: 0,
      phoneRq: 0,
      emailVal: "",

      suggestedPatients: [],
      showThisModel: false,
      CheckInData: [],
      currentSelectedReasonId: -1,
      showThisModelCheck: false,
      types: [],
      reasons: [],
      demos_1: [],
      actualDemos: [],
      actualQuestions: [],
      questionOptions: [],
      visitTypeQuestDemo: [],
      currentStep: 2,
      currentSelectedTypeId: -1,
      activeType: "",
      visitTypeReasons: "",
    };
  }, // data
  methods: {
    applySearchClick() {
        this.pageNumber = 1;
        this.getAllPatients();
      },
    //code for Data-Tables_
    pageChange(obj) {
        if (obj == "Next") {
          if (this.pageNumber < this.totalPages) {
            this.pageNumber += 1;
          }
        } else if (obj == "Previous" && this.pageNumber != 1) {
          this.pageNumber -= 1;
        } else {
          this.pageNumber = obj;
        }
  
        if((this.showPagesMax/2) < (this.pageNumber))
        {
          this.showPagesMin = this.pageNumber-4;
          this.showPagesMax = this.pageNumber+4;
        }
        else if((this.showPagesMin/2)<(this.pageNumber))
        {
          this.showPagesMin = this.pageNumber-4;
          this.showPagesMax = this.pageNumber+4 ;
          if(this.showPagesMax<5)
          {
            this.showPagesMax = 5;
          }
        }
        else{
          this.showPagesMin = 1;
          this.showPagesMax = 5 ;
        }
       this.getAllPatients();
      },
      orderBy(column) {
        if (this.sortColumn == column) {
          switch (this.sortColumnOption) {
            case 0:
              this.sortColumnOption = 1;
              break;
            case 1:
              this.sortColumnOption = 2;
              break;
            case 2:
              this.sortColumn = 0;
              this.sortColumnOption = 0;
              break;
          }
        } else {
          this.sortColumn = column;
          this.sortColumnOption = 1;
        }
        this.pageNumber = 1;
        this.getAllPatients();
      },

      orderByRemember(column) {
        if (this.firstTime == true) {
          this.firstTime = false;
          return;
        }
        this.orderByCol = column;
        if (column == 1) {
          if (this.asc_desc == "asc") {
            this.asc_desc = "desc";
            this.suggestedPatients = this.suggestedPatients.sort(
              (a, b) =>
                a.ptid < b.ptid ? 1 : b.ptid < a.ptid ? -1 : 0
            );
          } else {
            this.asc_desc = "asc";
            this.suggestedPatients = this.suggestedPatients.sort(
              (a, b) =>
                a.ptid > b.ptid ? 1 : b.ptid > a.ptid ? -1 : 0
            );
          }
        }
        if (column == 2) {
          if (this.asc_desc == "asc") {
            this.asc_desc = "desc";
            this.suggestedPatients = this.suggestedPatients.sort(
              (a, b) => (a.firstName < b.firstName ? 1 : b.firstName < a.firstName ? -1 : 0)
            );
          } else {
            this.asc_desc = "asc";
            this.suggestedPatients = this.suggestedPatients.sort(
              (a, b) => (a.firstName > b.firstName ? 1 : b.firstName > a.firstName ? -1 : 0)
            );
          }
        }
        if (column == 3) {
          if (this.asc_desc == "asc") {
            this.asc_desc = "desc";
            this.suggestedPatients = this.suggestedPatients.sort(
              (a, b) =>
                a.lastName < b.lastName ? 1 : b.lastName < a.lastName ? -1 : 0
            );
          } else {
            this.asc_desc = "asc";
            this.suggestedPatients = this.suggestedPatients.sort(
              (a, b) =>
                a.lastName > b.lastName ? 1 : b.lastName > a.lastName ? -1 : 0
            );
          }
        }
        if (column == 4) {
          if (this.asc_desc == "asc") {
            this.asc_desc = "desc";
            this.suggestedPatients = this.suggestedPatients.sort(
              (a, b) => (a.email < b.email ? 1 : b.email < a.email ? -1 : 0)
            );
          } else {
            this.asc_desc = "asc";
            this.suggestedPatients = this.suggestedPatients.sort(
              (a, b) => (a.email > b.email ? 1 : b.email > a.email ? -1 : 0)
            );
          }
        }
        if (column == 5) {
          if (this.asc_desc == "asc") {
            this.asc_desc = "desc";
            this.suggestedPatients = this.suggestedPatients.sort(
              (a, b) => (a.phone < b.phone ? 1 : b.phone < a.phone ? -1 : 0)
            );
          } else {
            this.asc_desc = "asc";
            this.suggestedPatients = this.suggestedPatients.sort(
              (a, b) => (a.phone > b.phone ? 1 : b.phone > a.phone ? -1 : 0)
            );
          }
        }
      },
  
    closeModal() {
    
      this.$emit("close-modal", false);
    },
    closeModalCheck() {
      this.showThisModelCheck = false;
      this.types = [];
      this.reasons = [];
      this.currentSelectedTypeId = -1;
      this.demos_1 = [];
    },
    reasonClick(ndx) {
      this.currentSelectedReasonId = this.visitTypeReasons[ndx].visitDetailId;
      this.activeReason = "";
      this.activeReason = JSON.parse(
        JSON.stringify(this.visitTypeReasons[ndx])
      );
      this.PhysicianId = this.visitTypeReasons[0].physicianId;

      //setBasic Detail
      this.choseBasic = [];
      this.demoClick = this.demos_1.filter(
        (i) => i.visitDetailId == this.currentSelectedReasonId
      );
      this.filterList();
    },
    filterList() {
      for (let i = 0; i < this.demoClick.length; i++) {
        if (
          this.demoClick[i].question == "First Name" ||
          this.demoClick[i].question == "LastName" ||
          this.demoClick[i].question == "DOB" ||
          this.demoClick[i].question == "SSN" ||
          this.demoClick[i].question == "Gender" ||
          this.demoClick[i].question == "Phone" ||
          this.demoClick[i].question == "Email" ||
          this.demoClick[i].question == "Street" ||
          this.demoClick[i].question == "City" ||
          this.demoClick[i].question == "Zip" ||
          this.demoClick[i].question == "State" ||
          this.demoClick[i].question == "Primary Insurance Name" ||
          this.demoClick[i].question == "ExternalId" ||
          this.demoClick[i].question == "Primary Insurance Number" ||
          this.demoClick[i].question == "Primary Insurance Group Name" ||
          this.demoClick[i].question == "Primary Insurance Image Upload" ||
          this.demoClick[i].question == "Secondary Insurance Name" ||
          this.demoClick[i].question == "Secondary Insurance Number" ||
          this.demoClick[i].question == "Secondary Insurance Group Name" ||
          this.demoClick[i].question == "Secondary Insurance Image upload"
        ) {
          this.choseBasic.push(this.demoClick[i]);
        }
      }
      this.demoClick = [];
    },
    setBasicRadio(val) {
      this.basicDetails.gender = val;
    },
    blankActiveDemo() {
      this.activeDemo = {
        reasonId: 0,
        visitDetailId: 0,
        setValue: 0,
        PhysicianId: "",
        demo: {
          questId: 0,
          srNo: 0,
          questName: "",
          question: "",
          answer: "",
          questionInputTypeId: 0,
          questTypeName: "",
          demoOptions: [],
        },
      };
      return this.activeDemo;
    },
    isCustomFound() {
      let found = false;
      for (let c = 0; c < this.contactInfo.length; c++) {
        for (let b = 0; b < this.choseBasic.length; b++) {
          if (
            this.contactInfo[c] == this.choseBasic[b].question.toLowerCase()
          ) {
            found = true;
            break;
          }
        }
      }
      return found;
    },
    visitTypeClick(ndx) {
      this.currentSelectedTypeId = this.types[ndx].visitTypeId;
      this.activeType = JSON.parse(JSON.stringify(this.types[ndx]));
      this.visitTypeReasons = [];
      const x = this.reasons.length;
      for (let i = 0; i < x; i++) {
        if (this.reasons[i].visitTypeId === this.activeType.visitTypeId) {
          this.visitTypeReasons.push(
            JSON.parse(JSON.stringify(this.reasons[i]))
          );
        }
      }
      this.activeReason = "";
      this.activeReason = JSON.parse(JSON.stringify(this.visitTypeReasons[0]));
    },

    //check values
    checkContact() {
      for (let j = 0; j < this.choseBasic.length; j++) {
        if (
          this.choseBasic[j].question == "Email" ||
          this.choseBasic[j].question == "Phone"
        ) {
          return true;
        }
      }
      return false;
    },

    backStageClick(step) {
      window.scrollTo(0, 0);
      if(step == 11 && this.isNew == false){
        this.currentStep = 3;
        return; 
      }
      if (step == 11) {
        if (this.isCustomFound() == true) {
          this.currentStep = 5;
          return;
        } else {
          this.currentStep = 4;
          return;
        }
      }

      if (step == 4) {
        this.currentStep = 4;
        return;
      }
    },

    checkPatient(){
      this.intDummyComm();
      this.dummyComm.extras1 = this.patientId;
      this.dummyComm.extras2 = this.Dos_1;
      const url = this.SERVER + "/STDS/StageDisplay/CheckVisitPat";
      const myData = this.dummyComm;

      this.axiosGetData(url, myData).then((res) => {
       //debugger
        this.loader.hide();
        if (res.extras == "0") {
          console.log("ok");
          this.currentStep = 3;
        } else {
          this.showMergeSwal();
        }
      });
     },

     showMergeSwal(){
      Swal.fire({
          title: "Are you sure?",
          text: "This Patient already has a visit for this Date of Service. Do you want to continue?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#00c292",
          confirmButtonText: "Continue",
        }).then((result) => {
          if (result.value) {
           this.currentStep = 3;
          }
        });
      },

    //**nextStageClick(step)
    nextStageClick(step) {
     //debugger
      window.scrollTo(0, 0);
      //Visit
      if (step === 4 && this.currentSelectedReasonId < 0) {
        this.warningToast("Enter Visit Reason");
        return;
      }

      if (step === 4 && this.isNew == false) {
        this.currentStep = 11;
        return;
      }

      if (step == 0) {
        window.history.go(-1);
        return;
      }
      if (this.checkinType == "") {
        this.warningToast("Select some Option");
        return;
      }

      //forCheckIn
      if (step == 1 && this.checkinType == "checkin") {
        this.currentStep = 1;
        return;
      }
      if (step === 3 && this.currentSelectedTypeId < 0) {
        this.warningToast("Enter Visit Type");
        return;
      }
      if(step == 3 && this.NewPat == 'false'){
        this.checkPatient();
        return;
      }
      //Basic
      if (step === 5) {
        for (let r = 0; r < this.choseBasic.length; r++) {
          if (this.choseBasic[r].question == "Phone") {
            this.phoneVal = "Phone";
            if (this.choseBasic[r].isRequired == 1) {
              this.phoneRq = 1;
            }
          } else if (this.choseBasic[r].question == "Email") {
            this.emailVal = "Email";
            if (this.choseBasic[r].isRequired == 1) {
              this.emailRq = 1;
            }
          } else if (this.choseBasic[r].question == "SSN") {
            this.ssnVal = "SSN";
            if (this.choseBasic[r].isRequired == 1) {
              this.ssnRequire = 1;
            }
          }
        }
        if (this.basicDetails.firstName.length < 1) {
          this.warningToast("First Name is require");
          return;
        }
        if (this.basicDetails.lastName.length < 1) {
          this.warningToast("Last Name is require");
          return;
        }
        if (this.basicDetails.dob.length < 1) {
          this.warningToast("Date of birth is require");
          return;
        }
        if (this.basicDetails.gender == "") {
          this.warningToast("Choose a Gender");
          return;
        }
        if (this.ssnVal != "" && this.ssnRequire == 1) {
          if (this.basicDetails.ssn.length < 1) {
            this.warningToast("Security Number is require");
            return;
          }
          if (
            this.basicDetails.ssn != "" &&
            this.basicDetails.ssn.length < 11
          ) {
            this.warningToast("Security number of must be 9 length");
            return;
          }
        }
        if (!this.isValidateDate(this.basicDetails.dob)) {
          this.warningToast("Valid Date of Birth required");
          event.preventDefault();
          return;
        }

        //set DOB, SSN value
        this.valueSSN = this.choseBasic.filter((i) => i.question == "SSN");
        if (this.valueSSN.length == 1) {
          this.valueSSN = "SSN";
        } else {
          this.valueSSN = "";
        }

        this.newValDOB = "";
        this.newValDOB = moment(String(this.basicDetails.dob)).format(
          "MM-DD-YYYY"
        );

        let found = false;
        for (let c = 0; c < this.contactInfo.length; c++) {
          for (let b = 0; b < this.choseBasic.length; b++) {
            if (
              this.contactInfo[c] == this.choseBasic[b].question.toLowerCase()
            ) {
              found = true;
              break;
            }
          }
        }
        if (found == false) {
          this.currentStep = 11;
          return;
        }

        this.currentStep = 5;
        return;
      }

      //Contact
      if (step === 6) {
        for (let p = 0; p < this.choseBasic.length; p++) {
          if (this.choseBasic[p].question == "Street") {
            this.addVal = "Street";
            if (this.choseBasic[p].isRequired == 1) {
              this.streetRq = 1;
            }
          } else if (this.choseBasic[p].question == "City") {
            this.cityVal = "City";
            if (this.choseBasic[p].isRequired == 1) {
              this.cityRq = 1;
            }
          } else if (this.choseBasic[p].question == "State") {
            this.stateVal = "State";
            if (this.choseBasic[p].isRequired == 1) {
              this.stateRq = 1;
            }
          } else if (this.choseBasic[p].question == "Zip") {
            this.zipVal = "Zip";
            if (this.choseBasic[p].isRequired == 1) {
              this.zipRq = 1;
            }
          }
        }
        if (this.phoneVal != "" && this.phoneRq == 1) {
          if (this.basicDetails.phone.length < 1) {
            this.warningToast("Phone Number is require");
            return;
          }
        }
        if (
          this.basicDetails.phone != "" &&
          this.basicDetails.phone.length < 12
        ) {
          this.warningToast("Phone Number must be of 10 length");
          return;
        }

        if (this.emailVal != "" && this.emailRq == 1) {
          if (this.basicDetails.email.length < 1) {
            this.warningToast("Email is require");
            return;
          }
        }
        if (this.basicDetails.email.length > 0) {
          if (this.basicDetails.email != null) {
            if (!this.validEmail(this.basicDetails.email)) {
              this.Validity(this.e);
            }
          }
        }

        this.currentStep = 11;
        return;
      }

      this.alertShown = 0;
      this.currentStep = step++;
    },

    showCheckInModalNew() {
      this.showQuickCheckinInfo();
    },
    async saveCheckinInfo_1() {
        await this.saveCheckinInfo();
      },
   async saveCheckinInfo() {
       this.call = setInterval(() => {
            this.showThisModelCheck = false;
          }, 4000);

      this.call1 = setInterval(() => {
            this.showThisModel = false;
          }, 4000);

      this.loader = this.$loading.show({
            color: "#03a9f3",
          });

      let stageStrt = new Date();
      this.basicDetails.stageTime =
      stageStrt.getFullYear() +
        "-" +
        String(stageStrt.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(stageStrt.getDate()).padStart(2, "0") +
        " " +
        String(stageStrt.getHours()).padStart(2, "0") +
        ":" +
        String(stageStrt.getMinutes()).padStart(2, "0") +
        ":" +
        String(stageStrt.getSeconds()).padStart(2, "0");

      //alert(currentdate.getFullYear());
      this.basicDetails.physicianId = this.activeReason.physicianId;
      this.basicDetails.externalId = "";

      this.Insurance = {
        primaryInsuranceName: "",
        primaryInsuranceNumber: "",
        primaryInsuranceGroup: "",
        primaryInsuranceId: "",
        secondaryInsuranceName: "",
        secondaryInsuranceNumber: "",
        secondaryInsuranceGroup: "",
        secondaryInsuranceId: "",
      };
     
     //debugger
      let getTime = new Date();
      let currentdate1 = new Date();
      this.newdate = moment(String(this.Dos_1)).format("MM/DD/YYYY");
      let ok = currentdate1.toLocaleDateString();

      const str = this.newdate;
      const arr = str.split("/");
      let one = arr[0].charAt(0)
      
      if(one == "0"){ this.newdate = this.newdate.replace(0, ""); }

      if(this.newdate === ok){
      this.basicDetails.dos = currentdate1.toLocaleDateString() + " " + getTime.toLocaleTimeString();
      }
      else{
      this.basicDetails.dos = this.newdate + " " + getTime.toLocaleTimeString();
      }

      let myData = {
        visitTypeId: this.activeType.visitTypeId,
        visitDetailId: this.activeReason.visitDetailId,
        questDemos: [],
        basicDetail: this.basicDetails,
        Insurance: this.Insurance,
        dc: this.dummyComm,
      };

      this.intDummyComm();
      this.dummyComm.emailValue = this.basicDetails.email;
      this.dummyComm.smsValue = this.basicDetails.phone;
      this.dummyComm.extras2 = this.practName;
     
      myData.dc = this.dummyComm;
      myData.dc.patientId = this.patientId;

      myData.PhysicianId = this.PhysicianId;
      //this.valueSSN = "";
      const url = this.SERVER + "/VNSPRAAPI/Checkin/SvChknPatQuick";
     
      this.loaderTim = setInterval(() => {
        this.loader.hide();
     }, 4000);
     
     this.loaderTim1 = setInterval(() => {
        this.loader.hide();
      }, 4000);

     await this.axiosGetData(url, myData).then((res) => {
          this.showThisModelCheck = false;
          this.showThisModel = false;
          this.loader.hide();
        if (res == "err") {
          this.showErrorToast("Unable to load data.");
        } else {
          this.successToast();
          this.types = [];
          this.reasons = [];
          this.currentSelectedTypeId = -1;
          this.demos_1 = [];
          this.basicDetails= {
            pndx: 0,
            patientId: 0,
            firstName: "",
            lastName: "",
            currentdate: new Date(),
            dos: "",
            dob: "",
            gender: "",
            ssn: "",
            phone: "",
            email: "",
            address: "",
            city: "",
            zip: "",
            state: "",
          }
       }
     })
      .catch(function (error) {
        if (error.response) {
          // alert("-> " + error.response.data);
          // alert("-> " + error.response.status);
          // alert("-> " + error.response.headers);
        } else if (error.request) {
          //alert("No response " + error.request);
        } else {
          //alert("Error", error.message);
        }
      })
      .finally(() => {
      });
    },

    showCheckInModal(pat) {
      this.getPatientFromMain(pat);
      // this.NewPat = 'false';
      //   clearTimeout(this.call);
      //   clearTimeout(this.loaderTim);

      //    this.loader = this.$loading.show({
      //       color: "#03a9f3",
      //     });
      // this.isNew = false;
      // this.currentStep = 2;
      // this.intDummyComm();
      // const url = this.SERVER + "/VNSPRAAPI/Checkin/GtBscDta1";
      // this.patientId = pat.patientId;
      // this.dummyComm.patientId = this.patientId;
      // const myData = this.dummyComm;

      // this.axiosGetData(url, myData).then((res) => {
      //   this.loader.hide();
      //   if (res == "err") {
      //     this.showErrorToast("Unable to load data.");
      //   } else {
      //    //debugger
      //     this.showThisModelCheck = true;
      //     this.types = res.visits;
      //     this.reasons = res.reasons;
      //     this.demos_1 = res.demos_1;
      //     this.basicDetails = res.basic[0];
      //     this.newValDOB = "";
      //     this.newValDOB = moment(String(this.basicDetails.dob)).format(
      //       "MM-DD-YYYY"
      //     );  
      //   }
      // });
    },


    getAllPatients() {
      var loader = this.$loading.show({
        color: "#03a9f3",
      });
      this.intDummyComm();
      const url = this.SERVER + "/VNSPRAAPI/Patient/GetAllPatientsCheckin";
      //this.dummyComm.filter = "";
      this.dummyComm.pageNumber = this.pageNumber;
      this.dummyComm.pageSize = this.pageSize;
      let stageId = 0;

     //debugger
      const myData = {
        dc: this.dummyComm,
        filter: this.$store.state.filterSTGDSP,
        sortColumn: this.sortColumn,
        sortColumnOption: this.sortColumnOption,
        stageId: stageId,
      };
     
      this.axiosGetData(url, myData).then((res) => {
        loader.hide();
        if (res == "err") {
          this.showErrorToast("Unable to load data.");
        } else {
          this.suggestedPatients = res.allPatients;
          if(this.suggestedPatients!=null)
          {for (let j = 0; j < this.suggestedPatients.length; j++) {
            this.suggestedPatients[j].dob = this.suggestedPatients[j].dob.split(
              "T"
            )[0];
            this.suggestedPatients[j].dob = moment(String(this.suggestedPatients[j].dob)).format("MM-DD-YYYY");
          }
        }
          this.totalRows = res.dc.totalRow;
          this.totalPages = res.dc.totalPages;
        }
      });
    },

    //-------------------- Common Methods
    async axiosGetData(myUrl, myData) {
      let data = "err";
      await axios({
        method: "post",
        url: myUrl,
        data: myData,
        contentType: "application/json",
        dataType: "json",
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          data = res.data;
        })
        .catch(function(err) {
          console.log(err);
        })
        .finally(() => {});

      return data;
    }, // axiosGetData
  }, // methods

  watch: {},
  mounted() {
    this.Dos_1 = moment(String(this.vDos)).format("YYYY-MM-DD")                       
    this.practName = localStorage.getItem("PracticeName");
    this.showThisModel = true;
    this.applySearchClick();
  },
  unmounted(){
      clearTimeout(this.call);
      clearTimeout(this.loaderTim);
  }
};
